module.exports = __webpack_public_path__ + "static/media/ic-medicine-heart-beat.ea9a3147.svg";